export interface GetInitialsOptions {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  fullName?: string | null
}

/**
 * Derives up-to-2-character initials, in priority order:
 * firstName + lastName -> fullName (first two words) -> first char of email.
 */
export const getInitials = ({
  firstName,
  lastName,
  email,
  fullName,
}: GetInitialsOptions): string => {
  const first = firstName?.charAt(0) ?? ''
  const last = lastName?.charAt(0) ?? ''
  if (first || last) {
    return `${first}${last}`.toUpperCase()
  }

  const nameParts = fullName?.trim().split(/\s+/).filter(Boolean) ?? []
  if (nameParts.length > 0) {
    return nameParts
      .slice(0, 2)
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase()
  }

  return (email?.charAt(0) ?? '').toUpperCase()
}
